var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vessel_record_by_flag"}},[_c('apexchart',{staticStyle:{"max-width":"1580px","min-width":"1186.8px"},attrs:{"type":"pie","height":"auto","options":_vm.chartOptions,"series":_vm.series},on:{"click":_vm.selectedBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }